module.exports = __webpack_public_path__ + "img/knowledge_tag@2x.6a900097.png";